export const iconFontAwesomeFilesFileCode = (
	<i className="fa-solid fa-file-code"></i>
);
